<template>
<div class="container-fluid">
  <PainelAcesso>
    <template #cabecalho >
      <div class="modal-title" v-if="!flags.exibirRecuperacaoSenhaSucesso">
        <div class="d-flex justify-content-center">
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 d-flex justify-content-between flex-row flex-wrap">
            <h5 class="text-bold text-left">
              Esqueceu sua Senha?
            </h5>
            <router-link :to="{name: 'loginLite'}" :disabled="flags.efetuandoRequisicao" class="text-center small"><span >Voltar para o login</span></router-link>
          </div>
        </div>
        <div v-if="flags.efetuandoRequisicao" class="d-flex justify-content-center divLoginSpinner mb-3">
          <span class="avisoDanger">Por favor, aguarde...</span>
          <b-spinner class="ml-2" variant="danger"></b-spinner>
        </div>
      </div>
    </template>
    <template #corpo>
      <form class="mt-4" v-if="!flags.exibirRecuperacaoSenhaSucesso" @submit.prevent="">
        <div class="form-row justify-content-center">
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
            <div v-show="mensagemAlerta" class="avisoDanger text-left mensagemAlerta mb-2">{{mensagemAlerta}}</div>
            <div v-show="flags.escritorioNaoLogado" class="avisoDanger text-left mb-2">{{erroValidacaoCampos.escritorio}}</div>
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
            <label class="small text-secondary" for="inputEmail">Recupere sua senha com Email ou CPF</label>
            <input
              type="text"
              @keyup="eventoRecuperarSenhaTeclaEnter"
              class="form-control form-control-md corBordaCampo"
              v-model="dadosFormulario.emailCpf"
              :placeholder="placeholder"
              autocomplete="email"
              v-mask="mask">
            <div class="avisoDanger text-left mt-2">{{erroValidacaoCampos.emailCpf}}</div>
          </div>
        </div>
        <div class="form-row justify-content-center">
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group" >
            <b-button variant="btn btn-verde btn-block " :disabled="flags.efetuandoRequisicao" @click="recuperar">Recuperar senha</b-button>
          </div>
          <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12 form-group">
            <p class="textos text-center">Não esqueça de verificar sua caixa de SPAM.</p>
          </div>
        </div>
      </form>
      <div v-else>
        <form class="mt-4">
          <div class="d-flex justify-content-center">
            <div class="col-xl-8 col-lg-8 col-md-12 col-sm-12">
              <h4 class="text-bold text-center">Recuperação de senha realizado com sucesso!</h4>
              <p class="textos mt-3">
                Verifique sua caixa de entrada, pois enviamos um email para <span class="text-bold" id="user-email">{{emailRecuperacao}}</span> contendo uma senha
                temporária para acessar sua conta.
              </p>
              <p class="textos">
                Recomendamos que você acesse sua conta o mais breve possível
                e altere a senha temporária por uma senha segura.
              </p>

              <router-link :to="{name: 'loginLite'}" :disabled="flags.efetuandoRequisicao" class="d-flex justify-content-center text-center"><span >Voltar para o login</span></router-link>
            </div>
          </div>
        </form>
      </div>
    </template>
  </PainelAcesso>
</div>
</template>

<script>
import RecuperacaoSenha from './js/recuperacao-senha.js'
export default RecuperacaoSenha
</script>

<style scoped>
@import "./scss/recuperacao-senha.scss";
</style>
